import { render, staticRenderFns } from "./project-activities.vue?vue&type=template&id=1fe65de6&scoped=true&"
import script from "./project-activities.vue?vue&type=script&lang=js&"
export * from "./project-activities.vue?vue&type=script&lang=js&"
import style0 from "./project-activities.vue?vue&type=style&index=0&id=1fe65de6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe65de6",
  null
  
)

export default component.exports